import { List, ListItem, Grid2 as Grid, FormControlLabel, Switch, useTheme, Typography } from "@mui/material";
import PreviousReceive from "./PreviousReceive";
import { useStyles } from "./Receive.styles";
import { PreviewReceiveList } from "./types";

export default function PreviousReceiveList(props: PreviewReceiveList) {
	const {
		receives,
		onReceiveEditClick,
		onReceivedQuantityChange,
		onSetReceiveProperty,
		isHardwareView,
		showDetailsOnly,
		isLockedForReview,
		onCostChange,
		onStartReview,
		onCancelReview,
		clearReceive,
		onHistoryClick,
		validateInvoiceNumber,
	} = props;
	const classes = useStyles();
	const theme = useTheme();
	const handleSwitchChange = (event) => {
		if (event.target.checked) {
			onStartReview && onStartReview();
		} else {
			onCancelReview && onCancelReview();
		}
	};

	const renderPreviousReceiveList = () => {
		if (receives && receives.length > 0) {
			return receives.map((receive) => {
				return (
					<Grid key={receive.id} container justifyContent="space-between" className={classes.mainGrid}>
						<PreviousReceive
							receive={receive}
							onReceiveEditClick={onReceiveEditClick}
							onReceivedQuantityChange={(sku, qty) => {
								onReceivedQuantityChange(receive.id,  sku,  qty);
							}}
							onCostChange={(sku, unitIncCost, unitExCost, lineIncCost, lineExCost) => {
								onCostChange(receive.id,  sku, unitIncCost, unitExCost, lineIncCost, lineExCost);
							}}
							isHardwareView={isHardwareView}
							showDetailsOnly={showDetailsOnly}
							isLockedForReview={isLockedForReview}
							onSetReceiveProperty={onSetReceiveProperty}
							clearReceive={clearReceive}
							onHistoryClick={onHistoryClick}
							validateInvoiceNumber={validateInvoiceNumber}
						/>
					</Grid>
				);
			});
		}
		return (
			<ListItem key="EmptyListReceives">
				<Typography variant="body1">There are currently no receives.</Typography>
			</ListItem>
		);
	};

	return (
		<Grid container size="grow">
			<Grid container direction="column" size="grow">
				{onStartReview && (
					<Grid>
						<FormControlLabel
							checked={isLockedForReview}
							control={<Switch color="secondary" />}
							label="Lock for review"
							onChange={handleSwitchChange}
						/>
					</Grid>
				)}
				<Grid size="grow" style={theme.fullWidth}>
					<List className={classes.previousReceiveListContainer}>{renderPreviousReceiveList()}</List>
				</Grid>
			</Grid>
		</Grid>
	);
}
